// src/components/profile/AccountForm.jsx
import React from "react";

export default function AccountForm({ form, onChange, onChangePhone }) {
  return (
    <div>
      <div className="border-b px-5 py-4">
        <h3 className="font-medium">계정</h3>
      </div>

      <div className="px-5 py-4 grid grid-cols-2 gap-4">
        <label className="text-sm">
          <div className="mb-1">성(Last Name)*</div>
          <input
            name="last_name"
            value={form.last_name}
            onChange={onChange}
            className="w-full rounded-md border px-3 py-2"
          />
        </label>

        <label className="text-sm">
          <div className="mb-1">이름(First Name)*</div>
          <input
            name="first_name"
            value={form.first_name}
            onChange={onChange}
            className="w-full rounded-md border px-3 py-2"
          />
        </label>

        <label className="text-sm">
          <div className="mb-1">아이디(변경 불가)</div>
          <input
            name="username"
            disabled
            value={form.username}
            className="w-full rounded-md border px-3 py-2 bg-gray-50"
          />
        </label>

        <label className="text-sm">
          <div className="mb-1">이메일*</div>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={onChange}
            className="w-full rounded-md border px-3 py-2"
          />
        </label>

        <label className="text-sm">
          <div className="mb-1">전화번호*</div>
          <input
            name="phone_number"
            value={form.phone_number}
            onChange={onChangePhone}
            className="w-full rounded-md border px-3 py-2"
          />
        </label>
      </div>
    </div>
  );
}
